import { render, staticRenderFns } from "./AlertasListaCompacta.vue?vue&type=template&id=466ea181&scoped=true&lang=pug"
import script from "./AlertasListaCompacta.vue?vue&type=script&lang=js"
export * from "./AlertasListaCompacta.vue?vue&type=script&lang=js"
import style0 from "./AlertasListaCompacta.vue?vue&type=style&index=0&id=466ea181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466ea181",
  null
  
)

export default component.exports